import * as React from "react";
import styles from "./../styles/textfield.module.scss";
import { Mail, Eye, EyeOff, Lock, User } from "react-feather";
import textfield_helper from "./../styles/textfield.module.scss";
import PropTypes from "prop-types";
import Tooltip from "../../../components/Tooltip";

const Textfield = props => {
  const { error, submitFailed, touched, valid } = props.meta;
  const hasError = touched && (!!error || !valid);
  const disabledStyle = props.disabled ? styles.__disabled : '';
  return (
    <section
      className={styles.__outer}
      data-tip={props.showTooltip ? props.id : null}
      data-for={props.showTooltip ? props.id : null}
    >
        {props.label &&  
          props.loginView ? 
          <label className={styles.__field__label} > {props.label} </label> 
          :
          <h4 className={styles.__text_left}>{props.label}</h4>
        }
      <section id={props.id} className={[styles.__bound, hasError ? styles.__hasError : '', disabledStyle].join(" ")}>
        {props.withIcon ? (
          <i className={styles.__icon}>
            {props.icon === "mail" ? (
              <Mail color="#69b6ff" />
            ) : props.icon === "user" ? (
              <User color="#69b6ff" />
            ) : props.icon === "lock" ? (
              <Lock color="#69b6ff" />
            ) : null}
          </i>
        ) : null}
        <input
          {...props.input}
          disabled={props.disabled}
          className={styles.__field}
          type={props.input_type}
          placeholder={props.input_placeholder}
          style={{marginTop: props.isSetting ? -13 : 0, marginLeft: props.isSetting ? -11 : 0}}
          autoComplete="off"
        />

        {props.viewPassword ? (
          <i
            className={[styles.__icon, styles.__icon__eye].join(" ")}
            onClick={props.viewPassword_press}
          >
            {props.viewPassword_icon === "eye" ? (
              <Eye color="#68D2DF" />
            ) : props.viewPassword_icon === "eyeoff" ? (
              <EyeOff color="#68D2DF" />
            ) : null}
          </i>
        ) : null}
      </section>
      {touched && !valid && props.showTooltip && (
        <Tooltip type="error" place="left" id={props.id} label={error} show={true}/>
      )}
      {touched && !valid && !props.showTooltip && (<label className={textfield_helper.__err_helper}>{error}</label>) }

      { submitFailed && error && (
        <label className={textfield_helper.__err_helper}>{error}</label>
      )}
      {props.children}
    </section>
  );
};

Textfield.propTypes = {
  input_placeholder: PropTypes.string,
  input_type: PropTypes.string.isRequired,
  icon: PropTypes.string,
  withIcon: PropTypes.bool,
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  viewPassword_press: PropTypes.func,
  viewPassword_icon: PropTypes.string,
  viewPassword: PropTypes.bool,
  id: PropTypes.string,
  children: PropTypes.func,
  showTooltip: PropTypes.bool
};

export default Textfield;
